module.exports = __webpack_public_path__ + "static/media/Swablu_gaussian2.6ff4a518.png";